import { defineMessages } from 'react-intl';

export default defineMessages({
  notFound: 'Nie odnaleziono danych spełniających kryteria wyszukiwania',
});
